import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SummitFormattedLine, SummitFormattedText } from '@summit/models';
import { SUiViewCodeComponent } from '../s-ui-view-code/s-ui-view-code.component';

@Component({
  selector: 's-ui-view-formatted-text',
  templateUrl: './s-ui-view-formatted-text.component.html',
  styleUrls: ['./s-ui-view-formatted-text.component.scss'],
  standalone: true,
  imports: [RouterModule, SUiViewCodeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SUiViewFormattedTextComponent {
  @Input() value: unknown;
  @Input() contentAlign: 'right' | 'left' = 'left';
  @Input() vAlign: 'top' | 'middle' | 'bottom' = 'top';
  showEllipsis = false;

  getFormattedTextLines(): SummitFormattedLine[] {
    const formattedText = this.value as SummitFormattedText;
    if (!formattedText) return [];
    if (formattedText.ellipsisAfterLine && formattedText.lines.length > formattedText.ellipsisAfterLine) {
      this.showEllipsis = true;
      return formattedText.lines.slice(0, formattedText.ellipsisAfterLine - 1);
    }
    this.showEllipsis = false;
    return (this.value as SummitFormattedText)?.lines;
  }

  isFormattedText(): boolean {
    return (this.value as SummitFormattedText)?.isFormattedText === true;
  }
}
